import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=53258454&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=53258454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53258454",
  null
  
)

export default component.exports